import { defineMessages } from 'react-intl';

export const messages: {
	ctaCancel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ctaPostUpdate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ctaForbiddenPostUpdate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	ctaCancel: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-footer.cta-cancel.non-final',
		defaultMessage: 'Cancel',
		description:
			'Button label displayed on the cancel button in the Atlassian project status update action card footer within the AI conversation interface. Shown as the text on a button. When clicked, it cancels the status update action and discards any changes. The purpose is to provide users with a way to exit the status update process without posting the update.',
	},
	ctaPostUpdate: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-footer.cta-post-update.non-final',
		defaultMessage: 'Post update',
		description:
			'Button label displayed on the primary action button in the Atlassian project status update action card footer within the AI conversation interface. Shown as the text on a button. When clicked, it posts the AI-generated project status update to the selected Atlassian project. The purpose is to provide a clear call-to-action for users to confirm and execute posting the project status update.',
	},
	ctaForbiddenPostUpdate: {
		id: 'conversation-assistant-message-actions.atlassian-project-status-update-action-renderer.card-footer.cta-forbidden-post-update.non-final',
		defaultMessage: 'Only contributors to this project can post updates.',
		description:
			'Tooltip or disabled state message displayed on the post update button in the Atlassian project status update action card footer within the AI conversation interface when the user does not have permission to post updates. Shown as a tooltip when hovering over a disabled button, or as disabled button text. The purpose is to inform the user why they cannot post the update, explaining that only project contributors have permission to post status updates.',
	},
});
